import { GoogleAddressValidationResponse } from '../types';

const VALID_GRANULARITY_VALUES = ['PREMISE', 'SUB_PREMISE'];

export const defineIsAddressValid = (addressValidationResult: GoogleAddressValidationResponse) => {
  const { addressComplete, validationGranularity } = addressValidationResult.result.verdict;

  return addressComplete && VALID_GRANULARITY_VALUES.includes(validationGranularity);
};
